module.exports = __webpack_public_path__ + "static/media/vaseQuestion.dc8a45b8.png";